export default __webpack_public_path__ + "static/media/later-funding.2c8b8c3f.svg";